module.exports = __webpack_public_path__ + "img/car-wash-white.a6be55ba.svg";